<template>
    <div class="side-navigation">
        <div :class="{'wrapper-side-logo': isJACareerEntrepreApp}">
            <div class="side-logo"></div>
            <div v-if="isJACareerEntrepreApp" class="side-app-name">
                <span class="side-app-name__title">
                    JA Future by Design: Careers
                </span>
            </div>
        </div>
        <b-nav vertical :class="{'isCareerEntrep': isJACareerEntrepreApp}" class="nav-side-navigation mb-5">
            <b-nav-text :class="{'disabled': lastStep<2, 'current': currentStep===2}">Deep Customer Empathy</b-nav-text>
            <b-nav-item :class="{'disabled': lastStep<3, 'current': currentStep===3}" :disabled="(lastStep<3)"
                        :to="{ name: 'js_deep_customer_empathy_3', params: { index } }">
                        Develop Your Self-Empathy
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<4, 'current': currentStep===4}" :disabled="(lastStep<4)"
                        :to="{ name: 'js_deep_customer_empathy_4', params: { index } }">
                        What did you learn from your customer (self) empathy work?
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<5, 'current': currentStep===5}" :disabled="(lastStep<5)"
                        :to="{ name: 'js_deep_customer_empathy_5', params: { index } }">
                       What did you learn from your customer empathy work?
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<6, 'current': currentStep===6}" :disabled="(lastStep<6)"
                        :to="{ name: 'js_deep_customer_empathy_6', params: { index } }">
                        Write your Customer Problem Statement
            </b-nav-item>
              <b-nav-item :class="{'disabled': lastStep<7, 'current': currentStep===7}" :disabled="(lastStep<7)"
                        :to="{ name: 'js_deep_customer_empathy_7', params: { index } }">
                        Write your Ideal State
            </b-nav-item>

            <b-nav-text :class="{'disabled' : lastStep<8, 'current': currentStep===8}">Go Broad to go narrow</b-nav-text>
            <b-nav-item :class="{'disabled': lastStep<9, 'current': currentStep===9}" :disabled="(lastStep<9)"
                        :to="{ name: 'js_go_broad_to_go_narrow_9', params: { index } }">
                        Brainstorming
            </b-nav-item>

            <b-nav-item :class="{'disabled': lastStep<10, 'current': currentStep===10}" :disabled="(lastStep<10)"
                        :to="{ name: 'js_go_broad_to_go_narrow_10', params: { index } }">
                        Go Broad: Brainstorm session summary
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<11, 'current': currentStep===11}" :disabled="(lastStep<11)"
                        :to="{ name: 'js_go_broad_to_go_narrow_11', params: { index } }">
                        Going Even More Narrow
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<12, 'current': currentStep===12}" :disabled="(lastStep<12)"
                        :to="{ name: 'js_go_broad_to_go_narrow_12', params: { index } }">
                        Go Narrow: What were the top ideas?
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<13, 'current': currentStep===13}" :disabled="(lastStep<13)"
                        :to="{ name: 'js_go_broad_to_go_narrow_13', params: { index } }">
                        Go Narrow: Which Career will you explore?
            </b-nav-item>
            <b-nav-text :class="{'disabled' : lastStep<14, 'current': currentStep===14}">Rapid Experiments With Customers</b-nav-text>
            <b-nav-item :class="{'disabled': lastStep<15, 'current': currentStep===15}" :disabled="(lastStep<15)"
                        :to="{ name: 'js_rapid_experiments_with_customers_15', params: { index } }">
                        Informational Interviewing
            </b-nav-item>
             <b-nav-item :class="{'disabled': lastStep<16, 'current': currentStep===16}" :disabled="(lastStep<16)"
                        :to="{ name: 'js_rapid_experiments_with_customers_16', params: { index } }">
                        Planning Informational Interviews
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<17, 'current': currentStep===17}" :disabled="(lastStep<17)"
                        :to="{ name: 'js_rapid_experiments_with_customers_17', params: { index } }">
                         Ready, Set, Interview!
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<18, 'current': currentStep===18}" :disabled="(lastStep<18)"
                        :to="{ name: 'js_rapid_experiments_with_customers_18', params: { index } }">
                        Interview Results
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<19, 'current': currentStep===19}" :disabled="(lastStep<19)"
                        :to="{ name: 'js_rapid_experiments_with_customers_19', params: { index } }">
                        Job Shadow
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<20, 'current': currentStep===20}" :disabled="(lastStep<20)"
                        :to="{ name: 'js_rapid_experiments_with_customers_20', params: { index } }">
                        Researching a Job Shadow Experience
            </b-nav-item>
            <b-nav-item :class="{'disabled': lastStep<21, 'current': currentStep===21}" :disabled="(lastStep<21)"
                        :to="{ name: 'js_rapid_experiments_with_customers_21', params: { index } }">
                        Preparing for a Job Shadow Experience
            </b-nav-item>
               <b-nav-item :class="{'disabled': lastStep<22, 'current': currentStep===22}" :disabled="(lastStep<22)"
                        :to="{ name: 'js_rapid_experiments_with_customers_22', params: { index } }">
                        Reflecting On Your Job Shadow Experience
            </b-nav-item>

        </b-nav>
    </div>
</template>

<script>
    import navigation from '../../../core/Mixins/navigation'

    export default {
        name: "JSNavigation",
        props: ['label'],
        mixins: [navigation],
    }
</script>

<style lang="stylus" scoped>
    @import "../../D4D/Styles/d4d_styles.styl"

    .side-logo
        content url("../../Home/Images/ja-job-shadow.jpg")
        background-repeat no-repeat
        width 100%
        height auto
        margin 0 auto
        background-position-y -120px
        border-radius 20px 20px 20px 20px
        box-shadow(0px 4px 5px 0px color-19)

    .wrapper-side-logo
        padding-top 20px
        width 100%
        height auto
        .side-logo
            border-radius 20px 20px 0 0

    .side-app-name
        background-color color-green-light
        height 75px
        display flex
        align-items center
        justify-content center
        border-radius 0 0 20px 20px
        box-shadow(0px 4px 5px 0px color-19)
        padding 0 15px

        &__title
            font font-poppins-semibold
            font-size 16px
            color color-blank

</style>
